import { z } from 'zod';
import { createPortalToolOutputSchema } from './portal-tool.schemas';
import { MCP_CREDENTIAL_DIALOG_TOOL_NAME } from './portal-tool.constants';

export { MCP_CREDENTIAL_DIALOG_TOOL_NAME };

export const McpCredentialDialogInputSchema = z.object({
  identityId: z
    .string()
    .optional()
    .describe('Optional MCP identity id to focus in the credential dialog.'),
});

export const McpCredentialDialogDataSchema = z.object({
  opened: z.boolean(),
});

export const McpCredentialDialogOutputSchema = createPortalToolOutputSchema({
  dataSchema: McpCredentialDialogDataSchema,
});

export type McpCredentialDialogInput = z.infer<
  typeof McpCredentialDialogInputSchema
>;
export type McpCredentialDialogOutput = z.infer<
  typeof McpCredentialDialogOutputSchema
>;
